export default __webpack_public_path__ + "static/media/clip.98bb46bc.svg";